import { VacantLandSalesProperty } from './types.js';
import { useVacantLandSalesMap } from './useVacantLandSalesMap.js';

export const VacantLandSalesMap = ({
  vacantLandSales,
  focusedPropertyId,
  setFocusedPropertyId,
  subjectLat,
  subjectLng,
}: {
  vacantLandSales: VacantLandSalesProperty[];
  focusedPropertyId: string | undefined;
  setFocusedPropertyId: (val: string | undefined) => void;
  subjectLat: number;
  subjectLng: number;
}) => {
  const { mapContainerRef } = useVacantLandSalesMap({
    vacantLandSales,
    focusedPropertyId,
    setFocusedPropertyId,
    subjectLat,
    subjectLng,
  });

  return <div ref={mapContainerRef} className="vacant-land-sales-map" />;
};
